const FEATURE_HELP_URLS = {
  agent_bots: 'https://rookoo.ai/hc/agent-bots',
  agents: 'https://rookoo.ai/hc/agents',
  audit_logs: 'https://rookoo.ai/hc/audit-logs',
  campaigns: 'https://rookoo.ai/hc/campaigns',
  canned_responses: 'https://rookoo.ai/hc/canned',
  channel_email: 'https://rookoo.ai/hc/email',
  channel_facebook: 'https://rookoo.ai/hc/fb',
  custom_attributes: 'https://rookoo.ai/hc/custom-attributes',
  dashboard_apps: 'https://rookoo.ai/hc/dashboard-apps',
  help_center: 'https://rookoo.ai/hc/help-center',
  inboxes: 'https://rookoo.ai/hc/inboxes',
  integrations: 'https://rookoo.ai/hc/integrations',
  labels: 'https://rookoo.ai/hc/labels',
  macros: 'https://rookoo.ai/hc/macros',
  message_reply_to: 'https://rookoo.ai/hc/reply-to',
  reports: 'https://rookoo.ai/hc/reports',
  sla: 'https://rookoo.ai/hc/sla',
  team_management: 'https://rookoo.ai/hc/teams',
  webhook: 'https://rookoo.ai/hc/webhooks',
  billing: 'https://rookoo.ai/pricing',
  planning: 'https://rookoo.ai/hc/planning',
  saml: 'https://github.com/rookoo-ai/rookoo-portal/blob/main/docs/MICROSOFT_ENTRA_SSO.md',
  scim: 'https://github.com/rookoo-ai/rookoo-portal/blob/main/docs/MICROSOFT_ENTRA_SSO.md',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
